export const PROTOCOL_ITEM_UPLOADER_PREFIX = 'protocol-item-uploader';
